import { render, staticRenderFns } from "./AdvertisersTable.vue?vue&type=template&id=a755e1b6&scoped=true"
import script from "./AdvertisersTable.vue?vue&type=script&lang=ts"
export * from "./AdvertisersTable.vue?vue&type=script&lang=ts"
import style0 from "./AdvertisersTable.vue?vue&type=style&index=0&id=a755e1b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a755e1b6",
  null
  
)

export default component.exports